import jQuery from 'jquery';
window.jQuery = window.$ = jQuery;

import PubSub from 'pubsub-js';

const easyAutocomplete = require('easy-autocomplete');

function initAutocomplete() {
  const autocompletes = $('*[data-autocomplete]');
  if (autocompletes.length) {

    autocompletes.each((index, autocomplete) => {
      let config = $(autocomplete).data('autocomplete');
      let options;
      // console.log(config);



      if (config == 'main_search_model') {
        options = {
          url: function(phrase) {
            let url = "/"+$("html").attr("lang")+"/discover/products/search?search=" + phrase.replace("%20"," ") + "&format=json";
            if ($(autocomplete).data('enpoint_url') !== undefined ) url = $(autocomplete).data('enpoint_url') + "?search=" + phrase.replace("%20"," ") + "&format=json";
            return url;
          },
          // data: [
          //   { name: "lorem ipsum", thumbnail: '/images/placeholder-product.png', url: '/products/1'},
          //   { name: 'Mussum Ipsum, cacilds vidis litro abertis', thumbnail: '/images/placeholder-product.png', url: '#2'},
          //   { name: 'Si u mundo tá muito paradi', thumbnail: '/images/placeholder-product.png', url: '#3'},
          //   { name: 'Toma um mé que o mundo vai girarzi', thumbnail: '/images/placeholder-product.png', url: '#4'},
          //   { name: 'Quem manda na minha terra sou euzi', thumbnail: '/images/placeholder-product.png', url: '#5'},
          //   { name: 'Mé faiz elementum girarzis, nisi eros vermeio', thumbnail: '/images/placeholder-product.png', url: '#6'},
          //   { name: 'Casamentiss faiz malandris se piruli', thumbnail: '/images/placeholder-product.png', url: '#7'}
          // ],
          getValue: 'name',
          list: {
            maxNumberOfElements: 5,
            match: { enabled: true },
            onLoadEvent: () => {
              // console.log('onLoadEvent');
              // console.log(autocomplete);
              console.log();
              $('.easy-autocomplete-container ul').append('<li><a  href="/'+$("html").attr("lang")+'/products?search='+$(autocomplete).val().replace(/\+/g," ")+'" class="start-search-button button expanded">See all results</a></li>');
            }
          },
          template: {
            type: 'custom',
            method: (value, item) => `
              <a href="${item.url}" class="t-autocomplete-form__result">
                <figure style="background-image: url('${item.thumbnail}')" class="t-autocomplete-form__result__image"></figure>
                <p class="t-autocomplete-form__result__label">${(value.length > 28) ? value.substring(0, 28)+'...' : value}</p>
              </a>
            `,
          },
        };
      } else if (config == 'filter_seach_model') {

        options = {
          data: [
            {
              label: "Roma",
              name: 'roma',
              id: 'location_roma',
              group: 'location'
            },
            {
              label: "Milan",
              name: 'milan',
              id: 'location_milan',
              group: 'location'
            },
            {
              label: "Bologna",
              name: 'bologna',
              id: 'location_bologna',
              group: 'location'
            },
            {
              label: "Torino",
              name: 'torino',
              id: 'location_torino',
              group: 'location'
            }
          ],
          getValue: 'label',
          list: {
            maxNumberOfElements: 5,
            match: { enabled: true }
          },
          template: {
            type: 'custom',
            method: (value, item) => `<button id="${item.id}" name="${item.name}" value="${item.label}" data-filter-group="${item.group}" data-filter-item="add">${item.label}</button>`,
          },
        };

      } else {
        options = config;
      }



      $(autocomplete).easyAutocomplete(options);
      $(autocomplete).parent('.easy-autocomplete').removeAttr('style');

      // $(autocomplete).keyup(function() {
      //   $(this).parent('.easy-autocomplete').find(".start-search-button").attr("href", "/search/products?search="+$(this).val());
      // });
    });
  }
}

jQuery(document).ready($ => {
  initAutocomplete();

  PubSub.subscribe('ResponsiveSidebar_changed', (msg, data) => {
    initAutocomplete();
  });
});
